import styled from 'styled-components';

export const PageSizeContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const PageSizeButton = styled.button<{ $isSelected: boolean }>`
    padding: 6px;
    min-width: 30px;
    height: 30px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border: none;
    cursor: pointer;
    font-size: 16px;
    font-weight: ${props => props.$isSelected ? 'bold' : 'normal'};
    color: ${props => props.$isSelected ? '#000' : '#666'};
    background-color: ${props => props.$isSelected ? 'rgba(249, 249, 249, 1)' : 'transparent'};
    border-radius: 6px;
    transition: background-color 0.2s ease, color 0.2s ease;

    &:hover {
        background-color: ${props => props.$isSelected ? 'rgba(249, 249, 249, 1)' : 'rgba(0, 0, 0, 0.04)'};
    }
`;
